import { render, staticRenderFns } from "./EmploymentDetailsInput.vue?vue&type=template&id=b88afd70"
import script from "./EmploymentDetailsInput.vue?vue&type=script&lang=js"
export * from "./EmploymentDetailsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports